module.exports = __webpack_public_path__ + "assets/img/5.2a7ee1ef.jpg";